import "./App.css";
import React from "react";
import ScatterGraph from "./components/ScatterGraph";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
           <Route path="/" element={<ScatterGraph />} /> 
        </Routes>
      </Router>
    </div>
  )
}

export default App;
